import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Utils
import { dateMMDDYY } from 'Shared/utils/DateTime.utils';

// Components
import { WpAlert } from 'Wpds/components/alert';

// Styles
import './GoalCompleteAlert.scss';

type Props = {
  goal: GoalItem;
};

const GoalCompleteAlert = ({ goal }: Props) => {
  const { isComplete, completedBy } = useGoal({ slug: goal.slug });
  const completerText = completedBy ? `by ${completedBy.displayName}` : null;
  const completedAt = dateMMDDYY(goal?.completedAt);
  const goalResolutionNote = goal?.resolutionNote;

  if (!isComplete) return null;

  const baseClassName = 'GoalCompleteAlert';

  return (
    <WpAlert type="success" iconPlacement="top">
      <div className={baseClassName}>
        <div className={`${baseClassName}__title`}>
          This goal was marked complete on {completedAt} {completerText}
        </div>
        {goalResolutionNote && (
          <>
            <div className={`${baseClassName}__note`}>Resolution notes</div>
            <div>{goalResolutionNote}</div>
          </>
        )}
      </div>
    </WpAlert>
  );
};

export default GoalCompleteAlert;
